import React from 'react'
import TMobileSalonAnalysis from '../components/dashboard/TMobileSalonAnalysis'

const TMobileSalonAnalysisPage = () => <TMobileSalonAnalysis />

export default TMobileSalonAnalysisPage
